import { useState, useEffect, Fragment } from "react"
import { useTranslation } from "react-i18next"
import { useUser } from "../../contexts/UserContext"
import { Button, List, Popconfirm, Flex } from "antd"
import { EditOutlined, DeleteOutlined, CalendarOutlined } from "@ant-design/icons"
import ProgramRibbon from "./ProgramRibbon"
import { mapPosition } from "../../utils/mappers"
import ProgramStepper from "./ProgramStepper"
import "./CardProgram.css"

const CardProgram = ({ program, isSelected, onClick, onEditSchedule, onEditProgram, onDeleteProgram, onRunProgram, onAbortProgram, onStepProgram, currentStep, currentTime, isRunning }) => {
    const { isReadOnly } = useUser()
    const { t } = useTranslation()
    const [isProgramRunning, setIsProgramRunning] = useState(isRunning)

    const handleSelectedProgramChange = () => onClick(program)

    const handleEditSchedule = () => onEditSchedule(program)
    const handleEditProgram = () => onEditProgram(program)
    const handleDeleteProgram = (index) => onDeleteProgram(program)

    //useState only initializes on the first render, not subsequent. Therefore we have to set it manually here
    useEffect(() => {
        setIsProgramRunning(isRunning);
    }, [isRunning]);


    const handleRunProgram = () => {
        setIsProgramRunning(true)
        onRunProgram(program)
    }

    const handleStopProgram = () => {
        onAbortProgram();
        setIsProgramRunning(false)
        // if (selectedProgram) {
        //     setShouldStartProgress(true)
        //     setCurrentStep(0)
        //     setProgressStep(0)
        //     setPercent(0)
        // }
    }

    const handleNextStep = () => {
        onStepProgram();
        // if (selectedProgram && currentStep < selectedProgram.steps.length - 1) {
        //     setShouldStartProgress(true)
        //     const nextStepIndex = currentStep + 1
        //     setCurrentStep(nextStepIndex)
        //     setProgressStep(nextStepIndex)
        //     setPercent(0)
        // }
    }

    function addLeadingZeroes(number)
    {
        return number < 10 ? "0" + number : number.toString()
    }

    return (
        <List.Item
            style={{ backgroundColor: isSelected ? "#e6f7ff" : "inherit", padding: "0.5rem 1rem" }}
            onClick={handleSelectedProgramChange}
        >
            <Flex style={{ width: "100%" }} vertical>
                <div className="program-data">
                    <h3>{currentTime > 1 && isProgramRunning ? program.programName + " " + addLeadingZeroes(Math.floor(currentTime / 60)) + ":" + addLeadingZeroes(currentTime % 60) : program.programName}</h3>

                    {!isReadOnly && (<div className="program-actions">
                        <Button icon={<CalendarOutlined />} onClick={handleEditSchedule}>
                            {t("page.card-details.program-list.program.actions.button.schema")}
                        </Button>
                        <Button icon={<EditOutlined />} onClick={handleEditProgram}>
                            {t("page.card-details.program-list.program.actions.button.edit")}
                        </Button>
                        <Popconfirm
                            title={t('page.card-details.cardprogram.removequestion')}
                            onConfirm={handleDeleteProgram}
                            okText={t('Yes')}
                            cancelText={t('No')}
                        >
                            {program.id == 0 ? (
                                <Button icon={<DeleteOutlined />} disabled>
                                    {t("page.card-details.program-list.program.actions.button.delete")}
                                </Button>
                            ) : (
                                <Button icon={<DeleteOutlined />} danger>
                                    {t("page.card-details.program-list.program.actions.button.delete")}
                                </Button>
                            )}
                        </Popconfirm>
                    </div>)}
                    <div className="program-steps">
                        {program.positions.map(({ positionID, timespan }, stepIndex) => (
                            <div key={stepIndex}>
                                <span>{stepIndex + 1}.</span>
                                <span>{t(`general.filter.valve.position.${mapPosition(positionID)}`)}</span>
                                <span>{timespan} min</span>
                            </div>
                        ))}
                    </div>

                    {/* <ol className="program-steps">
                        {program.positions.map(({ positionID, timespan }, stepIndex) => (
                            <li key={stepIndex}>
                                {t(`general.filter.valve.position.${mapPosition(positionID)}`)} - {timespan} min
                            </li>
                        ))}
                    </ol> */}
                    {/* </div> */}
                </div>
                {!isReadOnly && (
                    <>
                        {program && (isProgramRunning || isSelected) && (
                            <ProgramRibbon
                                isRunning={isProgramRunning}
                                onRunProgram={handleRunProgram}
                                onStopProgram={handleStopProgram}
                                onNextStep={handleNextStep}
                            />
                        )}
                        {isProgramRunning && <ProgramStepper steps={program.positions} currentStep={currentStep} progressStep={undefined} />}
                    </>
                )}
            </Flex>
        </List.Item>
    )
}
export default CardProgram
